const NotificationSuccess = ({ message }) => {
  return (
    <div
      className="flex items-center p-4 mb-4 text-sm text-green-500 border border-green-300 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800"
      role="alert"
    >
      <div>{message}</div>
    </div>
  );
};
export default NotificationSuccess;
